import { Modal } from  '../common/modal';
import GetACardTemplate from './GetACardModal.html';

export default class GetACardModal extends Modal {
    constructor() {
        let content = GetACardTemplate();
        let modalContents = {
            classes : ['GetACardModal'],
            title: window.html('getCard.needCard'),
            hiddenTitle: true,
            content
        };
        Cookies.set('gacPromoDismissed', 1, {httpOnly: false});
        super(modalContents);
    }
}
